import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ClientProfileForm from '../../components/client/ClientProfileForm';

/**
 * Client onboarding page displayed when a client first logs in
 */
const Onboarding: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Box px={6} py={4}>
      <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          {t('clientProfile.welcomeOnboarding')}
        </Typography>
        
        <Typography variant="body1" paragraph>
          {t('clientProfile.onboardingIntro')}
        </Typography>
      </Paper>
      
      <ClientProfileForm isOnboarding={true} />
    </Box>
  );
};

export default Onboarding;